import React, { useEffect, useState } from "react";
import { observer, inject } from "mobx-react";
import { useTranslation } from "react-i18next";
import { Button, Tabs, Text } from "../UI";
import { Tab } from "../UI/Tabs";
import LoadingContainer from "../layouts/LoadingContainer";
import Table from "../layouts/Table";
import styled, { useTheme } from "styled-components";
import TableRow from "../layouts/TableRow";
import MonthPicker from "../components/MonthPicker";
import NewExpense from "../components/NewExpense";
import Calender from "../UI/Calender/Calender";
import UpdateMonthReport from "../components/UpdateMonthReport";
import { SelectStatus } from "../UI/Select";
import ListImg from "../asserts/img/list_gray.svg";
import ListImgActive from "../asserts/img/list_white.svg";
import ListHover from "../asserts/img/list_blue.svg";
import CalenderHover from "../asserts/img/calender_blue.svg";
import CalenderImg from "../asserts/img/calender_gray.svg";
import CalenderImgActive from "../asserts/img/calender_white.svg";
import ErrorNotification from "../components/ErrorNotification";

const DisplayButton = styled.div(({ selected }) => ({
  background: selected ? "#0063FF" : "transparent",
  border: selected ? "none" : "1px solid #B1B1B1",
  borderRadius: 4,
  textAlign: "center",
  height: 32,
  width: 32,

  "&:hover": {
    border: "1px solid #1860D4",
    background: "#ECF3FF",
  },
}));

const MonthReports = ({
  userStore,
  expKeys,
  keys,
  monthReportsKeys,
  monthReports,
  handelRowDeleteClick,
  handelWorkHoursCalc,
  handleDateChange,
  handleStatusChange,
  onSaveExpense,
  onSaveReport,
  date,
  statuses,
  gl,
  period,
  error,
}) => {
  const { t, i18n } = useTranslation("month_reports");
  const isRtl = i18n.dir() === "rtl";
  const [selectedExp, setSelectedExp] = useState(undefined);
  const [isHover, setIsHover] = useState(null);
  const [selectedReport, setSelectedReport] = useState(undefined);
  const [showNewExpenseModal, setShowNewExpenseModal] = useState(false);
  const [showUpdateModal, setShowUpdateModal] = useState(false);
  const [tab, setTab] = useState("1");
  const [displayTable, setDisplayTable] = useState(true);
  const options =
    statuses
      ?.filter((stat) => stat.STATDES === "טיוטא" || stat.STATDES === "לאישור")
      .map((stat) => ({
        value: stat.DOCSTATUS,
        label: stat.STATDES,
      })) || [];
  const [showErrorNotification, setShowErrorNotification] = useState({
    show: false,
    text: "",
  });

  const theme = useTheme();

  useEffect(() => {
    const display = window.sessionStorage.getItem("display-report-as-table");
    if (!!display) {
      setDisplayTable(display === "true");
    }
  }, []);

  useEffect(() => {
    if (!!error) {
      setShowErrorNotification({
        show: true,
        text: error,
      });
    } else {
      setShowErrorNotification({
        show: false,
        text: "",
      });
    }
  }, [error]);

  const saveDisplay = (display) => {
    setDisplayTable(display);
    window.sessionStorage.setItem(
      "display-report-as-table",
      JSON.stringify(display)
    );
  };

  const handelRowClick = (expense) => {
    setSelectedExp(expense);
    setShowNewExpenseModal(true);
  };

  const handelReportRowClick = (report) => {
    setSelectedReport(report);
    setShowUpdateModal(true);
  };

  const handelNewExpense = () => {
    setSelectedExp(undefined);
    setShowNewExpenseModal(true);
  };

  return (
    <>
      <LoadingContainer>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            width: "100%",
            gap: 70,
            marginBottom: "-1.2em",
            padding: "24px 50px",
            alignItems: "center",
            gap: 5
          }}>
          <Text.H1 color="#4A69A6">{t("month_reports_title")}</Text.H1>
          <MonthPicker startDate={date} handleDateChange={handleDateChange} />
          <SelectStatus
            style={{
              flex: "0 1 9%",
              maxWidth: "110px",
              marginInlineStart: tab === "1" && "auto",
              marginLeft: 0,
            }}
            options={options}
            placeholder={t("choose")}
            value={monthReports?.STATDES || options[0]}
            backgroundColor={monthReports?.VCOLORNAME}
            onChange={(value) => handleStatusChange(value)}></SelectStatus>
        </div>
        {tab === "2" && (
          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              flexDirection: "row",
              position: "relative",
              alignItems: "center",
              top: 40,
              margin: "0 50px",
            }}>
            <Button onClick={() => handelNewExpense()} buttonStyle="main">
              {t("new_expense")}
            </Button>
          </div>
        )}
        {tab === "1" && (
          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              flexDirection: "row",
              position: "relative",
              alignItems: "center",
              top: 40,
              gap: 14,
            }}>
            <Button
              onClick={() => handelWorkHoursCalc()}
              style={{ width: "auto", paddingInline: 12 }}>
              {t("work_hours_calc")}
            </Button>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                borderRadius: 4,
                gap: 20,
                paddingInlineEnd: 50,
              }}>
              <DisplayButton
                onMouseEnter={() => setIsHover(1)}
                onMouseLeave={() => setIsHover(null)}
                selected={displayTable === true}
                onClick={() => saveDisplay(true)}>
                <img
                  src={
                    isHover === 1
                      ? ListHover
                      : displayTable === true
                      ? ListImgActive
                      : ListImg
                  }
                  alt="table"
                  style={{
                    cursor: "pointer",
                    verticalAlign: "middle",
                  }}
                />
              </DisplayButton>
              <DisplayButton
                onMouseEnter={() => setIsHover(2)}
                onMouseLeave={() => setIsHover(null)}
                selected={displayTable === false}
                onClick={() => saveDisplay(false)}>
                <img
                  src={
                    isHover === 2
                      ? CalenderHover
                      : displayTable === false
                      ? CalenderImgActive
                      : CalenderImg
                  }
                  alt="calender"
                  style={{
                    cursor: "pointer",
                    verticalAlign: "middle",
                  }}
                />
              </DisplayButton>
            </div>
          </div>
        )}
        <Tabs value={tab} tabChange={setTab} style={{ padding: "0 50px" }}>
          <Tab value="1" label={t("month_report")}>
            {displayTable === false ? (
              <Calender
                userStore={userStore}
                date={date}
                data={monthReports?.REP_EMPMONTH_SUBFORM || []}
              />
            ) : (
              <>
                <Table
                  handelRowClick={handelReportRowClick}
                  handelRowDeleteClick={handelRowDeleteClick}
                  hasDelete={false}
                  editable={true}
                  onClick={() => {}}
                  tab={1}
                  isRtl={isRtl}
                  keys={keys}
                  items={monthReports?.REP_EMPMONTH_SUBFORM || []}
                  translation={"month_reports"}
                  config={{ key: "CURDATE", direction: "ascending" }}
                  withIndex={false}
                  noPagination={true}
                  style={{ margin: "0 50px" }}
                />
                <div style={{ margin: "0 50px" }}>
                  <TableRow
                    backgroungColor={theme.color.label}
                    valueColor={theme.color.white}
                    key={keys.length}
                    handelRowClick={() => {}}
                    translation={"month_reports"}
                    labelInline={true}
                    keys={monthReportsKeys}
                    index={keys.length}
                    tab={1}
                    row={monthReports}
                    hasDelete={false}
                    withIndex={false}></TableRow>
                </div>
              </>
            )}
          </Tab>
          <Tab value="2" label={t("expenses")}>
            <Table
              handelRowClick={handelRowClick}
              handelRowDeleteClick={handelRowDeleteClick}
              hasDelete={true}
              editable={true}
              tab={2}
              keys={expKeys}
              items={monthReports?.REP_EMPEXPRETFILES_SUBFORM || []}
              translation={"month_reports"}
              noPagination={true}
              style={{ margin: "0 50px" }}
            />
          </Tab>
        </Tabs>
        {showErrorNotification.show && (
          <ErrorNotification
            text={showErrorNotification.text}
            onClose={() => setShowErrorNotification({ show: false })}
          />
        )}
      </LoadingContainer>
      {showNewExpenseModal === true && (
        <NewExpense
          onClose={setShowNewExpenseModal}
          onSave={onSaveExpense}
          selectedExp={selectedExp}
          period={period}
          gl={gl}
        />
      )}
      {showUpdateModal === true && (
        <UpdateMonthReport
          onClose={setShowUpdateModal}
          onSave={onSaveReport}
          selectedReport={selectedReport}
          period={period}
          gl={gl}
        />
      )}
    </>
  );
};

export default inject("userStore", "monthReportsStore")(observer(MonthReports));
